<template>
  <div>
    <NBar title="场地收益详情"/>
    <div style="width: 100%;background-color: white;">
      <div style="display: flex;align-items: center;margin: 0 10px;height: 50px;">
        <span style="font-size: 16px;margin-right:5px;">{{name}}</span>
        <div style="background-color: #194fff;border-radius: 3px;padding: 2px 5px;color: white;font-size: 12px;">
          {{deviceCount}}台
        </div>
      </div>
      <div style="display: flex;align-items: center;justify-content: space-between;margin: 0 10px;height: 40px;">
        <span style="font-size: 14px;">{{startTime + '至' + endTime}}</span>
        <div>
          <nut-price :price="onlinePayMoney" :needSymbol="false" :thousands="true"/>
          <span>元</span>
        </div>
      </div>
      <nut-cell title="设备类型" desc="全部设备" :show-icon="true"/>
      <div class="sort-div">
        <div class="item" @click="sortClick(0)"
             :style="{color:sort === 0 ? '#194fff' : '#cccccc',border:sort === 0 ? '1px solid #194fff' : '1px solid #cccccc'}">
          <span style="font-size: 14px;">编号</span>
          <div style="display: flex;flex-direction: column;justify-content: center;margin-left:5px;">
            <img :src="sort === 0 && sortType === 0 ? sortUpActive : sortUp" style="width: 13px;height: 13px;">
            <img :src="sort === 0 && sortType === 1 ? sortDownActive : sortDown" style="width: 13px;height: 13px;">
          </div>
        </div>
        <div class="item" @click="sortClick(1)"
             :style="{color:sort === 1 ? '#194fff' : '#cccccc',border:sort === 1 ? '1px solid #194fff' : '1px solid #cccccc'}">
          <span style="font-size: 14px;">收益</span>
          <div style="display: flex;flex-direction: column;justify-content: center;margin-left:5px;">
            <img :src="sort === 1 && sortType === 0 ? sortUpActive : sortUp" style="width: 13px;height: 13px;">
            <img :src="sort === 1 && sortType === 1 ? sortDownActive : sortDown" style="width: 13px;height: 13px;">
          </div>
        </div>
        <img @click="dialogShow = true"
             :src="require('../../../resource/img/device/svg/help.svg')"
             style="margin-left: 10px;width: 20px;height: 20px;">
        <nut-dialog title="温馨提示" :visible="dialogShow" ok-btn-txt="我知道了" @ok-btn-click="dialogShow=false"
                    :no-cancel-btn="true">
          线上收益 = 在线支付收益+平台补贴
        </nut-dialog>
      </div>
    </div>
    <div v-for="(item, index) in list" :key="index" style="width: 100%;margin-top: 10px;">
      <nut-cell>
        <span slot="title" style="font-size: 16px;">{{item.name + item.deviceId}}</span>
        <span slot="desc" style="font-size: 14px;color: #2d2d2d;">
          <span style="margin-right: 5px;">合计:</span>
          <nut-price :price="item.onlinePayMoney" :needSymbol="false" :thousands="true"/>
          <span>元</span>
        </span>
      </nut-cell>
      <nut-cell :show-icon="true"
                :to="`/device/EarningsDetail?deviceId=${item.deviceId}&startTime=${startTime}&endTime=${endTime}`">
        <span slot="title" style="font-size: 16px;">线上收益</span>
        <span slot="desc" style="font-size: 14px;color: #2d2d2d;">
          <nut-price :price="item.onlinePayMoney" :needSymbol="false" :thousands="true"/>
          <span>元</span>
        </span>
      </nut-cell>
    </div>
  </div>
</template>

<script>
/**
 * 场地收益详情
 */
export default {
  name: 'SiteEarningsDetail',
  props: ['addressId', 'name', 'deviceCount', 'onlinePayMoney', 'startTime', 'endTime'],
  data () {
    return {
      dialogShow: false,
      //排序类型 0升序 1降序
      sortType: 0,
      //0编号 1收益
      sort: 0,
      sortUp: require('../../../resource/img/device/svg/sort-up.svg'),
      sortUpActive: require('../../../resource/img/device/svg/sort-up_active.svg'),
      sortDown: require('../../../resource/img/device/svg/sort-down.svg'),
      sortDownActive: require('../../../resource/img/device/svg/sort-down_active.svg'),
      page: 1,
      limit: 20,
      list: []
    }
  },
  activated () {
    this.getData()
  },
  methods: {
    getData () {
      let time1 = new Date(this.startTime.replace(/-/g, '/') + ' 00:00:00')
      let time2 = new Date(this.endTime.replace(/-/g, '/') + ' 23:59:59')
      let data = {
        startTime: time1.getTime() / 1000,
        endTime: time2.getTime() / 1000,
        addressId: this.addressId,
        sort: this.sort,
        sortType: this.sortType,
        page: this.page,
        limit: this.limit
      }
      if (!this.$util.isArrOrNull(this.$api.merId)) {
        data.merId = this.$api.merId
      }
      if (!this.$util.isArrOrNull (this.$api.user.merIds)) {
        data.merIds = this.$api.user.merIds
      }
      this.$api.post({
        url: '/device/api/device/address/earnings/device/list',
        data: data
      }).then(res => {
        this.list = res.data
      })
    },
    /**
     * 排序点击事件
     * @param sort
     */
    sortClick (sort) {
      this.sort = sort
      if (this.sortType === 0) {
        this.sortType = 1
      } else {
        this.sortType = 0
      }
      this.getData()
    }
  }
}
</script>

<style scoped>
  >>> .nut-dialog-btn:only-child {
    color: #194fff;
  }

  >>> .nut-dialog-ok:active {
    background: #1a87ff;
    color: white;
  }

  .sort-div {
    display: flex;
    align-items: center;
  }

  .sort-div .item {
    user-select: none;
    margin: 10px 0 10px 10px;
    display: flex;
    align-items: center;
    border: 1px solid #cccccc;
    background-color: white;
    border-radius: 5px;
    height: 30px;
    padding: 0 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/device/home/SiteEarningsDetail.vue